/**
 * @fileoverview Module for `src/lib/ScrollToTop.js`.
 */

// From https://reactrouter.com/web/guides/scroll-restoration

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll restoration component for route transitions.
 *
 * @returns {null} Always returns null.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
